import { render, staticRenderFns } from "./VendorSettingsForm.vue?vue&type=template&id=fde398e2&"
import script from "./VendorSettingsForm.vue?vue&type=script&lang=js&"
export * from "./VendorSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports